import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from '../../../services/global.service';
import { SubscriptionsGymItemExt, SubscriptionsOrder, SubscriptionAlert } from '../../../interfaces/subscription';
import { Gym } from '../../../interfaces/gym';
import { GymProgram } from '../../../interfaces/gymprogram';

@Component({
  selector: 'app-pack',
  templateUrl: './pack.component.html',
  styleUrls: ['./pack.component.scss']
})
export class SubscriptionsPackComponent implements OnInit {

  public creatorPrograms: GymProgram[];
  public pack: GymProgram;
  public packGymList: SubscriptionsGymItemExt[];
  public alerts: SubscriptionAlert;

  constructor(private route: ActivatedRoute,
    private translate: TranslateService,
    private globalService: GlobalService) {

    this.creatorPrograms = this.route.snapshot.data.creatorPrograms;
    this.pack = this.creatorPrograms.find(obj => obj.id === Number(this.route.snapshot.paramMap.get('id')));      
    this.packGymList = this.route.snapshot.data.packGymList;
    this.alerts = this.route.snapshot.data.alerts;    
  }

  ngOnInit() {
    this.globalService.changePageTitle([this.translate.instant('SUBSCRIPTIONS.TITLE') + ' - ' + this.translate.instant('SUBSCRIPTIONS.PACK') + ' ' + this.pack.name]);
  }

}
